import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Combined field of text and select.
 * @inheritDoc
 */
export class FormModelTextSelect extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'textselect';

  /**
   * @inheritDoc
   * @param id
   * @param secondId The id of the select field.
   * @param validators
   * @param options List of options for the select field.
   * @param values
   * @param info
   * @param fieldType
   */
  constructor(id: string, secondId: string, validators: ValidatorFn[] = [], options: string[], values: string[] = [], info: boolean = true, fieldType: string = 'text') {
    super(id, validators, null, null, info);

    this.options = options;
    this.fieldData["secondId"] = secondId;
    this.fieldData["fieldType"] = fieldType;
    this.fieldData["values"] = values;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelTextSelect {
    // @ts-ignore
    return new this.constructor(this.id, this.fieldData["secondId"], this.validators, this.options, this.fieldData["values"], this.info, this.fieldData["fieldType"]);
  }

  /**
   * @inheritDoc
   */
  getIds(): string[] {
    return [this.id, this.fieldData["secondId"]];
  }
}
